import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-export";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
Amplify.configure(awsExports);


root.render(
  <App />
);
